<template>
	<div id="choixsystemeventilation">

		<Breadcrump/>
		<v-flex	xs12 md12>
			<v-tabs v-model="active" color="cyan" dark slider-color="yellow">
				<v-tab key="1" ripple>
					<h3>AANVRAGEN VAN EEN VENTILATIESTUDIE</h3>
				</v-tab>
				<v-tab-item key="1">
					<v-card color="grey lighten-5" class="mb-5">
						<v-layout column>
							<v-flex	xs12 md4>
								<v-flex	xs12 md6 offset-sm1>
									<p> &nbsp; </p>
									<h3>Dit aanvraagformulier dient vergezeld te zijn van
										<ul>
											<li>Een compleet bouwplan (plattegronden, snedes) (*)</li>
											<li>Gevraagde reductiefactor (*)</li>
											<li>VVO (Ventilatie VoorOntwerp)</li>
										</ul>
									</h3>
									<p> &nbsp; </p>
								</v-flex>
							</v-flex>
						</v-layout>
					</v-card>
				</v-tab-item>

				<v-tab key="2" ripple>
					<h3>INSTALLATEUR</h3>
				</v-tab>
				<v-tab-item key="2">
					<v-stepper v-model="currentStep" vertical non-linear>
						<!-- Misuse 'editable' to make it possible to click through the steps => All clickable elements are done -->
						<v-stepper-step
							:editable="importStep >= 1"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 1"
							step="1">
							<h3>Installateur</h3>
						</v-stepper-step>

						<v-stepper-content step="1">
							<v-card color="grey lighten-5" class="mb-5">
								<v-layout column>
									<v-layout row wrap>
										<v-flex	xs7 md4 xl4 offset-sm1>
											<v-checkbox	v-model="sts" label="Ik ben STS gecertificeerd"></v-checkbox>						
										</v-flex>
									</v-layout>
									<v-flex xs12 md4 offset-sm1>
										<v-text-field v-model="nom" label="Naam (*):"></v-text-field>
									</v-flex>

									<v-flex	xs12 md4 offset-sm1>
										<v-text-field v-model="adresse" label="Adres (*):"></v-text-field>
									</v-flex>

									<v-flex	xs5 md5 xl5 offset-sm1>
										<v-text-field v-model="email" label="E-mail (*):" @blur="emailValidation"></v-text-field>
									</v-flex>
									
									<v-alert :value="emailValidationText !== ''" type="error">{{ emailValidationText }}</v-alert>

									<v-flex	xs12 md4 offset-sm1>
										<v-text-field v-model="projet" label="Projectnaam (*):"></v-text-field>
									</v-flex>

									<v-flex	 v-if="nom.length < 3 || adresse.length < 3 || email.length < 3 || projet.length < 3" xs12 md6 offset-sm1>
										(*) Verplicht (minimum 3 drukletters)
									</v-flex>
								</v-layout>
								
							</v-card>

							<v-btn v-if="nom.length >= 3 && adresse.length >= 3 && email.length >= 3 && projet.length >= 3" color="primary" @click="currentStep = 2; importStep = Math.max(importStep, 2)">Ok</v-btn>
							<v-btn flat  disabled>Vorige</v-btn>
						</v-stepper-content>
					</v-stepper>	
									
				</v-tab-item>
		
				<v-tab key="3" ripple>
					<h3>KEUZE VENTILATIESYSTEEM</h3>
				</v-tab>
				<v-tab-item key="3">
					<v-stepper v-model="currentStep" vertical non-linear>
						<!-- Misuse 'editable' to make it possible to click through the steps => All clickable elements are done -->
						<v-stepper-step
							:editable="importStep >= 2"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 2"
							step="2">
							<h3>Type systeem : {{ systeme }}</h3>
						</v-stepper-step>

						<v-stepper-content step="2">
							<v-card color="grey lighten-5" class="mb-5" >
								<v-radio-group v-model="systeme" :mandatory="false">
									<v-radio label="C systeem" value="C"></v-radio>
									<v-radio label="D systeem" value="D"></v-radio>
								</v-radio-group>
								<div v-if="systeme === 'C'">
									<v-flex	xs12 md6 offset-sm1>
										<v-radio-group v-model="aerateurs" :mandatory="false">
											<v-radio label="met gestuurde raamroosters" value="aerateur_tronic"></v-radio>
											<v-radio label="met manuele raamroosters" value="aerateur_manuel"></v-radio>
										</v-radio-group>
									</v-flex>
								</div>
							</v-card>
							<v-btn v-if="aerateurs !== '' || systeme === 'D'" color="primary" @click="currentStep = 3; importStep = Math.max(importStep, 3)">Ok</v-btn>
							<v-btn flat disabled>Vorige</v-btn>
						</v-stepper-content>

						<v-stepper-step
							:editable="importStep >= 3"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 3"
							step="3">
							<h3>Gevraagde reductiefactor</h3>
						</v-stepper-step>

						<v-stepper-content step="3">
							<v-card color="grey lighten-5" class="mb-5">
								<v-flex xs6 md3>
									<v-combobox v-model="facteur_reduction" :items="facteurs_reduction_d" label="Gevraagde reductiefactor"></v-combobox>
								</v-flex>
							</v-card>
							<v-btn v-if="facteur_reduction !== ''" color="primary" @click="currentStep = 4; importStep = Math.max(importStep, 4)">Ok</v-btn>
							<v-btn flat  @click="currentStep = 2">Vorige</v-btn>
						</v-stepper-content>
						
						<v-stepper-step
							:editable="importStep >= 4"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 4"
							step="4">
							<h3>Waar komt de ventilatieunit ?</h3>
						</v-stepper-step>
						
						<v-stepper-content step="4">
							<v-card color="grey lighten-5" class="mb-5">
								<v-flex xs12 md6>
									<v-text-field v-model="localisation_unite" label="Waar komt de ventilatieunit ? (*)"></v-text-field>
								</v-flex>
								<v-flex	 v-if="localisation_unite.length < 3" xs12 md6>
									(*) Verplicht (minimum 3 drukletters)
								</v-flex>
							</v-card>
							<v-btn v-if="localisation_unite.length >= 3" color="primary" @click="currentStep = 5; importStep = Math.max(importStep, 5)">Ok</v-btn>
							<v-btn flat  @click="currentStep = 3">Vorige</v-btn>
						</v-stepper-content>

						<v-stepper-step
							:editable="importStep >= 5"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 5"
							step="5">
							<h3>Lucht naar buiten :</h3>
						</v-stepper-step>	
						<v-stepper-content step="5">
							<v-card color="grey lighten-5" class="mb-5">								
								<v-flex	xs12 md12 xl12>
									<v-layout column="">
										<v-flex xs6 md3 xl3	>
											<v-radio-group v-model="rejet_ext" :mandatory="false">
												<v-radio label="Muurdoorvoer" value="rejet_mur"></v-radio>
												<v-radio label="Dakdoorvoer" value="rejet_toit"></v-radio>
											</v-radio-group>
										</v-flex>
										<div v-if="rejet_ext === 'rejet_toit'">
											<v-flex xs3 md3 xl2 offset-sm1="">							
												<v-text-field type="number"  min="0" max="90"
													v-model="inclinaison_toit_rejet"
													label="hellingsgraad dak (°)"
													required
												></v-text-field>
											</v-flex>
										</div>
									</v-layout>
								</v-flex>
							</v-card>						
							<v-btn v-if="(rejet_ext === 'rejet_toit' && inclinaison_toit_rejet >=0 && inclinaison_toit_rejet <=90) || rejet_ext === 'rejet_mur'" color="primary" @click="currentStep = 6; importStep = Math.max(importStep, 6)">Ok</v-btn>
							<v-btn flat  @click="currentStep = 4">Vorige</v-btn>
						</v-stepper-content>

						<v-stepper-step
							:editable="importStep >= 6"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 6"
							step="6">
							<h3>Buitenlucht aanzuig :</h3>
						</v-stepper-step>	
						<v-stepper-content step="6">
							<v-card color="grey lighten-5" class="mb-5">								
								<v-flex	xs12 md12 xl12>
									<v-layout column>
										<v-flex	xs6	md3	xl3>
											<v-radio-group v-model="prise_ext" :mandatory="false">
												<v-radio label="Muurdoorvoer" value="prise_mur"></v-radio>
												<v-radio label="Dakdoorvoer" value="prise_toit"></v-radio>
											</v-radio-group>
										</v-flex>
										<div v-if="prise_ext === 'prise_toit'">
											<v-flex	xs3	md3	xl2 offset-sm1>							
												<v-text-field type="number" min="0" max="90"
													v-model="inclinaison_toit_prise"
													label="hellingsgraad dak (°)"
													required
												></v-text-field>
											</v-flex>
										</div>
									</v-layout>
								</v-flex>
							</v-card>						
							<v-btn  v-if="(prise_ext === 'prise_toit' && inclinaison_toit_prise >=0 && inclinaison_toit_prise <=90) || prise_ext === 'prise_mur'" color="primary" @click="currentStep = 7; importStep = Math.max(importStep, 7)">Ok</v-btn>
							<v-btn flat  @click="currentStep = 5">Vorige</v-btn>
						</v-stepper-content>

						<v-stepper-step
							:editable="importStep >= 7"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 7"
							step="7">
							<h3>Voorkeur merk :</h3>
						</v-stepper-step>	
						<v-stepper-content step="7">
							<v-card color="grey lighten-5" class="mb-5">								
								<v-flex	xs12 md12 xl12>
									<v-layout row wrap>
										<v-flex	xs6 md6	xl6>
											<v-radio-group v-model="preference_marque" :mandatory="false">
												<v-radio label="Duco" value="duco"></v-radio>
												<v-radio label="Ventiline" value="ventiline"></v-radio>
											</v-radio-group>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-card>						
							<v-btn  v-if="(prise_ext === 'prise_toit' && inclinaison_toit_prise !== '') || prise_ext === 'prise_mur'" color="primary" @click="currentStep = 8; importStep = Math.max(importStep, 8)">Ok</v-btn>
							<v-btn flat  @click="currentStep = 6">Vorige</v-btn>
						</v-stepper-content>
					</v-stepper>

				</v-tab-item>
		
				<v-tab key="4" ripple>
					<h3>KEUZE LUCHTKANAALSYSTEEM</h3>
				</v-tab>
				<v-tab-item key="4">
					<v-stepper v-model="currentStep" vertical non-linear>
						<!-- Misuse 'editable' to make it possible to click through the steps => All clickable elements are done -->
						<v-stepper-step
							:editable="importStep >= 8"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 8"
							step="8">
							<h3>Technische koker voor stijgleidingen ?</h3>
						</v-stepper-step>

						<v-stepper-content step="8">
							<v-card color="grey lighten-5" class="mb-5" >
								<v-layout row wrap>
									<v-flex	xs3 md1>
										<v-radio-group v-model="gaine_technique" :mandatory="false">
											<v-radio label="Ja" value="gaine_technique_oui"></v-radio>
											<v-radio label="Neen" value="gaine_technique_non"></v-radio>
										</v-radio-group>
									</v-flex>
									<v-flex	xsç md5 offset-sm1>
										<div v-if="gaine_technique === 'gaine_technique_oui'">
											<v-flex	xs9 md9>
												<v-text-field v-model="localisation_gaine_technique" label="Waar is de technische koker ? (*)"></v-text-field>
												<u>Afmetingen :</u>
												<v-text-field type="number" min="10" max="10000" v-model="longueur_gaine_technique" label="Lengte (cm) min. 10 cm"></v-text-field>
												<v-text-field type="number" min="10" max="10000" v-model="largeur_gaine_technique" label="Breedte (cm) min. 10 cm"></v-text-field>
											</v-flex>
											<v-flex	 v-if="localisation_gaine_technique.length < 3" xs12 md6>
												(*) Verplicht (minimum 3 drukletters)
											</v-flex>

										</div>
									</v-flex>
								</v-layout>
							</v-card>
							<v-btn v-if= "gaine_technique === 'gaine_technique_non' || 
									(gaine_technique === 'gaine_technique_oui' && 
									localisation_gaine_technique.length >= 3 && 
									longueur_gaine_technique >= 10  && 
									largeur_gaine_technique >= 10)" 
									color="primary" @click="currentStep = 9; importStep = Math.max(importStep, 9)">Ok</v-btn>
							<v-btn flat disabled>Vorige</v-btn>
						</v-stepper-content>

						<v-stepper-step
							:editable="importStep >= 9"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 9"
							step="9">
							<h3><u>Inplanting leidingen </u></h3>
							<h4>Voor ventilatie kelder : </h4>
						</v-stepper-step>

						<v-stepper-content step="9">
							<v-card color="grey lighten-5" class="mb-5" >
								<v-layout row wrap>
									<v-flex	xs5 md3>
										<v-radio-group v-model="gainage_cave" :mandatory="false">
											<v-radio label="Chape" value="cave_chape"></v-radio>
											<v-radio label="Vals plafond" value="cave_faux_plafond"></v-radio>
											<v-radio label="Opbouw (Galva)" value="cave_apparent"></v-radio>
											<v-radio label="Geen" value="cave_aucun"></v-radio>
										</v-radio-group>
									</v-flex>
									<v-flex	xs6 md5 xl5>
										<div v-if="gainage_cave === 'cave_chape'">
											<v-combobox v-model="gainage_cave_chape_diam" :items="items" label="diameter (mm)"></v-combobox>
										</div>

										<div v-if="gainage_cave === 'cave_faux_plafond'">
											<v-text-field type="number" min="10" max="10000" v-model="cave_hauteur_faux_plafond" label="beschikbare hoogte (cm) min. 10 cm"></v-text-field>
										</div>
									</v-flex>
								</v-layout>

								<div v-if="gainage_cave !== '' && gainage_cave !== 'cave_aucun' && 
										(((gainage_cave  === 'cave_chape' && gainage_cave_chape_diam !== '') || 
										(gainage_cave  === 'cave_faux_plafond' && cave_hauteur_faux_plafond !== '')) ||
										gainage_cave  === 'cave_apparent') "> 
									<h5>Keuze ventiel :</h5>
									<v-flex	xs3 md3>
										<v-radio-group v-model="bouches_cave" :mandatory="false">
											<v-radio label="Standaard" value="cave_bouches_standards"></v-radio>
											<v-radio label="Design" value="cave_bouches_design"></v-radio>
										</v-radio-group>
									</v-flex>
								</div>
							</v-card>
							<v-btn v-if= "((gainage_cave === 'cave_apparent' ||
								(gainage_cave === 'cave_chape' && gainage_cave_chape_diam !== '') ||
								(gainage_cave === 'cave_faux_plafond' && cave_hauteur_faux_plafond >=10)) && 
								bouches_cave !== '') || gainage_cave === 'cave_aucun' " 
								color="primary" @click="currentStep = 10; importStep = Math.max(importStep, 10)">Ok
							</v-btn>
							<v-btn flat @click="currentStep = 8">Vorige</v-btn>
						</v-stepper-content>

						<v-stepper-step
							:editable="importStep >= 10"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 10"
							step="10">
							<h3><u>Inplanting leidingen </u></h3>
							<h4>Voor ventilatie gelijkvloers :</h4>
						</v-stepper-step>

						<v-stepper-content step="10">
							<v-card color="grey lighten-5" class="mb-5" >
								<v-layout row wrap>
									<v-flex	xs5 md3>
										<v-radio-group v-model="gainage_rez" :mandatory="false">
											<v-radio label="Chape" value="rez_chape"></v-radio>
											<v-radio label="Vals plafond" value="rez_faux_plafond"></v-radio>
											<v-radio label="Opbouw (Galva)" value="rez_apparent"></v-radio>
										</v-radio-group>
									</v-flex>
									<v-flex	xs6 md5 xl5>
										<div v-if="gainage_rez === 'rez_chape'">
												<v-combobox v-model="gainage_rez_chape_diam" :items="items" label="diameter (mm)"></v-combobox>
										</div>

										<div v-if="gainage_rez === 'rez_faux_plafond'">
											<v-text-field type="number" min="10" max="10000" v-model="rez_hauteur_faux_plafond" label="beschikbare hoogte (cm) min. 10 cm"></v-text-field>
										</div>
									</v-flex>
								</v-layout>
								<div v-if="gainage_rez !== '' && gainage_rez !== 'rez_aucun' && 
										(((gainage_rez  === 'rez_chape' && gainage_rez_chape_diam !== '') || 
										(gainage_rez  === 'rez_faux_plafond' && rez_hauteur_faux_plafond !== '')) ||
										gainage_rez  === 'rez_apparent') "> 
									<h5>Keuze ventiel :</h5>
									<v-flex	xs5 md3>
										<v-radio-group v-model="bouches_rez" :mandatory="false">
											<v-radio label="Standaard" value="rez_bouches_standards"></v-radio>
											<v-radio label="Design" value="rez_bouches_design"></v-radio>
										</v-radio-group>
									</v-flex>
								</div>
							</v-card>
							<v-btn v-if= "((gainage_rez === 'rez_apparent' ||
									(gainage_rez === 'rez_chape' && gainage_rez_chape_diam !== '') ||
									(gainage_rez === 'rez_faux_plafond' && rez_hauteur_faux_plafond >=10)) && 
									bouches_rez !== '') || gainage_rez === 'rez_aucun' " 
								color="primary" @click="currentStep = 11; importStep = Math.max(importStep, 11)">Ok
							</v-btn>
							<v-btn flat @click="currentStep = 9">Vorige</v-btn>
						</v-stepper-content>

						<v-stepper-step
							:editable="importStep >= 11"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 11"
							step="11">
							<h3><u>Inplanting leidingen </u></h3>
							<h4>Voor ventilatie eerste verdieping :</h4>
						</v-stepper-step>

						<v-stepper-content step="11">
							<v-card color="grey lighten-5" class="mb-5" >
								<v-layout row wrap>
									<v-flex	xs5 md3>
										<v-radio-group v-model="gainage_et1" :mandatory="false">
											<v-radio label="Chape" value="et1_chape"></v-radio>
											<v-radio label="Vals plafond" value="et1_faux_plafond"></v-radio>
											<v-radio label="Opbouw (Galva)" value="et1_apparent"></v-radio>
											<v-radio label="Geen" value="et1_aucun"></v-radio>
										</v-radio-group>
									</v-flex>
									<v-flex	xs6 md5 xl5>
										<div v-if="gainage_et1 === 'et1_chape'">
												<v-combobox v-model="gainage_et1_chape_diam" :items="items" label="diameter (mm)"></v-combobox>
										</div>

										<div v-if="gainage_et1 === 'et1_faux_plafond'">
											<v-text-field type="number" min="10" max="10000" v-model="et1_hauteur_faux_plafond" label="beschikbare hoogte (cm) min. 10 cm"></v-text-field>
										</div>
									</v-flex>
								</v-layout>
								<div v-if="gainage_et1 !== '' && gainage_et1 !== 'et1_aucun' && 
										(((gainage_et1  === 'et1_chape' && gainage_et1_chape_diam !== '') || 
										(gainage_et1  === 'et1_faux_plafond' && et1_hauteur_faux_plafond !== '')) ||
										gainage_et1  === 'et1_apparent') "> 
									<h5>Keuze ventiel :</h5>
									<v-flex	xs5 md3>
										<v-radio-group v-model="bouches_et1" :mandatory="false">
											<v-radio label="Standaard" value="et1_bouches_standards"></v-radio>
											<v-radio label="Design" value="et1_bouches_design"></v-radio>
										</v-radio-group>
									</v-flex>
								</div>
							</v-card>
							<v-btn v-if= "((gainage_et1 === 'et1_apparent' ||
									(gainage_et1 === 'et1_chape' && gainage_et1_chape_diam !== '') ||
									(gainage_et1 === 'et1_faux_plafond' && et1_hauteur_faux_plafond >=10)) && 
									bouches_et1 !== '')" 
								color="primary" @click="currentStep = 12; importStep = Math.max(importStep, 12)">Ok
							</v-btn>
							<v-btn v-if= "gainage_et1 === 'et1_aucun' " 
								color="primary" @click="currentStep = 13; importStep = Math.max(importStep, 13)">Ok
							</v-btn>
							<v-btn flat @click="currentStep = 10">Vorige</v-btn>
						</v-stepper-content>

						<div v-if="gainage_et1 !== 'et1_aucun'">
							<v-stepper-step
								:editable="importStep >= 12"
								edit-icon="$vuetify.icons.complete"
								:complete="importStep > 12"
								step="12">
								<h3><u>Inplanting leidingen </u></h3>
								<h4>Voor ventilatie tweede verdieping :</h4>
							</v-stepper-step>

							<v-stepper-content step="12">
								<v-card color="grey lighten-5" class="mb-5" >
									<v-layout row wrap>
										<v-flex	xs5 md3>
											<v-radio-group v-model="gainage_et2" :mandatory="false">
												<v-radio label="Chape" value="et2_chape"></v-radio>
												<v-radio label="Vals plafond" value="et2_faux_plafond"></v-radio>
												<v-radio label="Opbouw (Galva)" value="et2_apparent"></v-radio>
												<v-radio label="Geen" value="et2_aucun"></v-radio>
											</v-radio-group>
										</v-flex>
										<v-flex	xs6 md5 xl5>
											<div v-if="gainage_et2 === 'et2_chape'">
													<v-combobox v-model="gainage_et2_chape_diam" :items="items" label="diameter (mm)"></v-combobox>
											</div>

											<div v-if="gainage_et2 === 'et2_faux_plafond'">
												<v-text-field type="number" min="10" max="10000" v-model="et2_hauteur_faux_plafond" label="beschikbare hoogte (cm) min. 10 cm"></v-text-field>
											</div>
										</v-flex>
									</v-layout>
									<div v-if="gainage_et2 !== '' && gainage_et2 !== 'et2_aucun' && 
											(((gainage_et2  === 'et2_chape' && gainage_et2_chape_diam !== '') || 
											(gainage_et2  === 'et2_faux_plafond' && et2_hauteur_faux_plafond !== '')) ||
											gainage_et2  === 'et2_apparent') "> 
										<h5>Keuze ventiel :</h5>
										<v-flex	xs5 md3>
											<v-radio-group v-model="bouches_et2" :mandatory="false">
												<v-radio label="Standaard" value="et2_bouches_standards"></v-radio>
												<v-radio label="Design" value="et2_bouches_design"></v-radio>
											</v-radio-group>
										</v-flex>
									</div>
								</v-card>
							<v-btn v-if= "((gainage_et2 === 'et2_apparent' ||
									(gainage_et2 === 'et2_chape' && gainage_et2_chape_diam !== '') ||
									(gainage_et2 === 'et2_faux_plafond' && et2_hauteur_faux_plafond >=10)) && 
									bouches_et2 !== '') || gainage_et2 === 'et2_aucun' " 
								color="primary" @click="currentStep = 13; importStep = Math.max(importStep, 13)">Ok
							</v-btn>
								<v-btn flat @click="currentStep = 11">Vorige</v-btn>
							</v-stepper-content>
						</div>	
					</v-stepper>


				</v-tab-item>

				<v-tab key="5" ripple>
					<h3>BIJLAGE</h3>
				</v-tab>
				<v-tab-item key="5">
					<v-stepper v-model="currentStep" vertical non-linear>
						<!-- Misuse 'editable' to make it possible to click through the steps => All clickable elements are done -->
						<v-stepper-step
							:editable="importStep >= 13"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 13"
							step="13">
							<h3>Bestanden uploaden</h3>
						</v-stepper-step>

						<v-stepper-content step="13">
							<v-card color="grey lighten-5" class="mb-5">
								<v-layout column>
									<v-flex xs12 sm8>
										<v-flex xs12 sm7 offset-sm1>
											<h4>
											<ul>
												<li>Een compleet bouwplan (plattegronden, snedes)*</li>
												<li>VVO (Ventilatie VoorOntwerp)</li>
											</ul>
											</h4>
											<br>
											<p class="body-1">
											Groepeer alle bestanden in een map, selecteer die om te uploaden (20 MB maxi).
											<br><br>
											<input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload(filesOk, filesTooBig)"/>
											</p>
											<v-alert :value="filesTooBig" type="error">Te grote bestanden !</v-alert>
										</v-flex>
									</v-flex>					
								</v-layout>

							</v-card>
							<v-btn v-if="files && filesOk" color="primary" @click="currentStep = 14; importStep = Math.max(importStep, 14)">Ok</v-btn>
							<v-btn flat  disabled>Vorige</v-btn>
						</v-stepper-content>

						<v-stepper-step
							:editable="importStep >= 14"
							edit-icon="$vuetify.icons.complete"
							:complete="importStep > 14"
							step="14">
							<h3>Data verzenden</h3>
						</v-stepper-step>

						<v-stepper-content step="14">
							<v-card color="grey lighten-5" class="mb-5" v-if="api_status !== 'mail_sent'">
								<v-layout column>
									<h4 >Als u zeker bent van uw gegevens :</h4>

									<v-flex class="text-xs-center mt-3">
										<p>
											<v-btn color="success" block v-on:click="submitFiles(
												nom,
												adresse,
												email,
												projet,
												sts,
												localisation_unite,
												systeme,
												aerateurs,
												rejet_ext,
												prise_ext,
												inclinaison_toit_rejet,
												inclinaison_toit_prise,
												preference_marque,
												gaine_technique,
												localisation_gaine_technique,
												longueur_gaine_technique,
												largeur_gaine_technique,
												gainage_cave,
												gainage_cave_chape_diam,
												bouches_cave,
												gainage_rez,
												gainage_rez_chape_diam,
												bouches_rez,
												gainage_et1,
												gainage_et1_chape_diam,
												bouches_et1,
												gainage_et2,
												gainage_et2_chape_diam,
												bouches_et2,
												cave_hauteur_faux_plafond,
												rez_hauteur_faux_plafond,
												et1_hauteur_faux_plafond,
												et2_hauteur_faux_plafond,
												facteur_reduction)">Verzenden</v-btn>
										</p>
									</v-flex>
									<v-flex v-if="is_loading">
										<v-progress-linear :indeterminate="true"></v-progress-linear>
									</v-flex>

								</v-layout>
							</v-card>
							<v-flex class="text-xs-center mt-3">
								<v-chip class="white--text" v-if="api_status === 'mail_sent'" color="success"><h3>Uw gegevens zijn verzonden. Dank U voor uw aanvraag !</h3></v-chip>
								<v-chip class="white--text" v-if="api_status === 'mail_not_sent'" color="warning"><h3>Uw gegevens zijn NIET verzonden ! {{ attachment_oversize_text }}</h3></v-chip>
								<v-chip class="white--text" v-if="axios_error !== ''" color="error"><h3>{{ axios_error }} !</h3></v-chip>
							</v-flex>

						</v-stepper-content>

					</v-stepper>


				</v-tab-item>

			</v-tabs>
		</v-flex>
		<div class="text-xs-center mt-3" v-if="emailValidationText == '' && (active == 0 || (active == 1 && currentStep == 2) || (active == 2 && currentStep == 8) || (active == 3 && currentStep == 13))">
			<v-btn @click="next">Volgende ></v-btn>
		</div>



	</div>
</template>

<script>

	import Breadcrump from './Breadcrump';
	import axios from 'axios';

    export default {
		name: 'Formulaire',
		components: {
			Breadcrump
		},
		data: function () {
			return {
				filesOk: false,
				filesTooBig: false,
				filesSize: 0,
				emailValidationText: '',
				nom: '',
				adresse: '',
				email: '',
				projet: '',
				sts: false,
				localisation_unite: '',
				systeme:'',
				aerateurs: '',
				rejet_ext: '',
				prise_ext: '',
				inclinaison_toit_rejet: '',
				inclinaison_toit_prise: '',
				preference_marque: '',
				gaine_technique: '',
				localisation_gaine_technique: '',
				longueur_gaine_technique: '',
				largeur_gaine_technique: '',
				gainage_cave: '',
				gainage_cave_chape_diam: '',
				bouches_cave: '',
				gainage_rez: '',
				gainage_rez_chape_diam: '',
				bouches_rez: '',
				gainage_et1: '',
				gainage_et1_chape_diam: '',
				bouches_et1: '',
				gainage_et2: '',
				gainage_et2_chape_diam: '',
				bouches_et2: '',
				cave_hauteur_faux_plafond: '',
				rez_hauteur_faux_plafond: '',
				et1_hauteur_faux_plafond: '',
				et2_hauteur_faux_plafond: '',
				facteur_reduction: '',
				currentStep: 1,
				importStep: 1,
				active: null,
				files: '',
				info: '',
				api_status: '',
				attachment_size: 0,
				attachment_oversize: false,
				axios_error: '',
				is_loading: false,
				postBody: '',
				errors: [],
				items: [
					'50',
					'63',
					'70',
					'90',
					'60x130'
				],
				facteurs_reduction_c: [
					'1,00',
					'0,95',
					'0,87',
					'0,81',
					'0,70',
					'0,65',
					'0,61',
					'0,56',
					'0,53',
					'0,49',
					'0,48',
					'0,45'
				],
				facteurs_reduction_d: [
					'0,90',
					'0,79',
					'0,66',
					'0,61',
					'0,55',
					'0,53',
					'0,50',
					'0,48',
					'0,47',
					'0,43',
					'0,42',
					'0,38',
					'0,35'
				]				
			}
		},
		created() {
			axios.interceptors.request.use((config) => {
				this.setLoading(true);
				return config;
			}, (error) => {
				this.setLoading(false);
				return Promise.reject(error);
			});

			axios.interceptors.response.use((response) => {
				this.setLoading(false);
				return response;
			}, (error) => {
				this.setLoading(false);
				return Promise.reject(error);
			});
		},
		mounted () {
			
		},
		methods: {		
			setLoading(is_loading) {
				
				if (is_loading) {
					this.is_loading = true;
				} else if (this.ref_count > 0) {
					this.is_loading = false;
				}
			},
			/*
				Submits all of the files to the server
			*/
			submitFiles(				
				nom,
				adresse,
				email,
				projet,
				sts,
				localisation_unite,
				systeme,
				aerateurs,
				rejet_ext,
				prise_ext,
				inclinaison_toit_rejet,
				inclinaison_toit_prise,
				preference_marque,
				gaine_technique,
				localisation_gaine_technique,
				longueur_gaine_technique,
				largeur_gaine_technique,
				gainage_cave,
				gainage_cave_chape_diam,
				bouches_cave,
				gainage_rez,
				gainage_rez_chape_diam,
				bouches_rez,
				gainage_et1,
				gainage_et1_chape_diam,
				bouches_et1,
				gainage_et2,
				gainage_et2_chape_diam,
				bouches_et2,
				cave_hauteur_faux_plafond,
				rez_hauteur_faux_plafond,
				et1_hauteur_faux_plafond,
				et2_hauteur_faux_plafond,
				facteur_reduction) {
				/*
					Initialize the form data
				*/
				let formData = new FormData();

				/*
					Iteate over any file sent over appending the files
					to the form data.
				*/
				for( var i = 0; i < this.files.length; i++ ){
					let file = this.files[i];

					formData.append('files[' + i + ']', file);
				}

				/*
					Make the request to the POST /multiple-files URL
				*/
				var link = 'http://domoserver.ddns.net/ventilatie-form/axios/api.php';
				link = link+"?langue=nl";
				link = link+"&nom="+nom;
				link = link+"&adresse="+adresse;
				link = link+"&email="+email;
				link = link+"&projet="+projet;
				link = link+"&sts="+sts;
				link = link+"&localisation_unite="+localisation_unite;
				link = link+"&systeme="+systeme;
				link = link+"&aerateurs="+aerateurs;
				link = link+"&rejet_ext="+rejet_ext
				link = link+"&prise_ext="+prise_ext;				
				link = link+"&inclinaison_toit_rejet="+inclinaison_toit_rejet;				
				link = link+"&inclinaison_toit_prise="+inclinaison_toit_prise;				
				link = link+"&preference_marque="+preference_marque;				
				link = link+"&gaine_technique="+gaine_technique;
				link = link+"&localisation_gaine_technique="+localisation_gaine_technique;
				link = link+"&longueur_gaine_technique="+longueur_gaine_technique;				
				link = link+"&largeur_gaine_technique="+largeur_gaine_technique;				
				link = link+"&gainage_cave="+gainage_cave;				
				link = link+"&gainage_cave_chape_diam="+gainage_cave_chape_diam;				
				link = link+"&bouches_cave="+bouches_cave;				
				link = link+"&gainage_rez="+gainage_rez;				
				link = link+"&gainage_rez_chape_diam="+gainage_rez_chape_diam;				
				link = link+"&bouches_rez="+bouches_rez;				
				link = link+"&gainage_et1="+gainage_et1;				
				link = link+"&gainage_et1_chape_diam="+gainage_et1_chape_diam;				
				link = link+"&bouches_et1="+bouches_et1;				
				link = link+"&gainage_et2="+gainage_et2;		
				link = link+"&gainage_et2_chape_diam="+gainage_et2_chape_diam;
				link = link+"&bouches_et2="+bouches_et2;				
				link = link+"&cave_hauteur_faux_plafond="+cave_hauteur_faux_plafond;				
				link = link+"&rez_hauteur_faux_plafond="+rez_hauteur_faux_plafond;				
				link = link+"&et1_hauteur_faux_plafond="+et1_hauteur_faux_plafond;				
				link = link+"&et2_hauteur_faux_plafond="+et2_hauteur_faux_plafond;				
				link = link+"&facteur_reduction="+facteur_reduction;	
				
				this.axios_error='';

				this.axios.post( link,
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}
				).then(response => {
					this.info = response;
					this.api_status = response.data.api_status;
					this.attachment_size = response.data.attachment_size;
					if (response.data.attachment_size > 20 * 1024 * 1024) {
						this.attachment_oversize=true;
						this.attachment_oversize_text = "Te grote bestanden.";
					}
					this.axios_error='';
				}).catch((error) => {
					this.axios_error=error;
				})
			},

			/*
				Handles a change on the file upload
			*/
			handleFilesUpload(filesOk, filesTooBig){
				var filesSize = 0;
				
				this.files = this.$refs.files.files;
				for (var i=0; i<this.files.length; i++) {
					filesSize = filesSize+this.files[i].size;
				}
				console.log("filesSize:"+filesSize);
				if (filesSize > 20*1024*1024) { // si taille fichiers > 20MB
					this.filesTooBig = true;
					this.filesOk = false;
				} else {
					this.filesTooBig = false;
					this.filesOk = true;
				}
				console.log("fileOk : "+this.filesOk+" fileTooBig : "+this.filesTooBig);
			},

			next () {
				const active = parseInt(this.active)
				this.active = (active < 6 ? active + 1 : 0)
			},
			
			emailValidation (){
				if (!this.email) {
					this.emailValidationText = 'e-mail verplicht.';
				} else {
					this.emailValidationText = '';
				}
				if (!this.validEmail(this.email)) {
					this.emailValidationText='Geldige e-mail vereist.';
				} else {
					this.emailValidationText = '';
				}
			},
			
			validEmail: function (email) {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(email);
			}
		}
	}
</script>

<style>
h2 {
	margin: 10px;
}
</style>
